import { currentUser } from "lib/currentUser"
import { deleteSignedInCookie, justSignedIn } from "lib/currentUser/session"
import { push } from "lib/googleTagManager/dataLayer"

export async function pushUserDetails() {
  const user = await currentUser()
  const userId = user?.id || ""

  push({
    event: "user_details",
    user_id: userId,
  })

  if (justSignedIn()) {
    push({
      event: "login",
      user_id: userId,
    })

    deleteSignedInCookie()
  }
}

export async function pushNewsletterSubscription() {
  if (!window.GTM?.NewsletterListSubscriptionEvent) {
    return
  }

  const user = await currentUser()
  const userId = user?.id || ""

  push({
    event: "newsletter_sub",
    user_id: userId,
    product_name: window.GTM.NewsletterListSubscriptionEvent.listName,
  })
  push({
    event: "page_view",
  })
}

export async function pushArticleDetails() {
  if (!window.GTM?.ArticleDetailsEvent) {
    return
  }

  push(window.GTM.ArticleDetailsEvent)
}

/**
 * Article complete event is pushed when the user reaches the end of the article.
 * It contains the same data as the article details event, but with a different event name.
 */
export async function pushArticleComplete() {
  if (!window.GTM?.ArticleDetailsEvent) {
    return
  }

  const articleDetailsEvent = window.GTM.ArticleDetailsEvent || {}
  const articleCompleteEvent = { ...articleDetailsEvent, event: "article_complete" }

  push(articleCompleteEvent)
}

export async function pushCustomDimensions() {
  if (!window.GTM?.CustomDimensions) {
    return
  }

  push(window.GTM.CustomDimensions)
}

pushCustomDimensions()
pushUserDetails()
pushNewsletterSubscription()
pushArticleDetails()
